import React, { Fragment, Component } from 'react'
import {
    Container,
    Row, Col,
    CardBody, Card, CardTitle, CardSubtitle,
    Button,
    Fieldset, Legend
} from "reactstrap"
import { ConfirmAlert } from '../../../../../helpers/ui/alert'
import { FileInput, generateFormData } from '../../../../../helpers/ui/FileInput'
import CustomSelect from '../../../../../helpers/ui/CustomSelect'
import { AvForm, AvGroup, AvInput, AvField, AvCheckboxGroup, AvCheckbox } from "availity-reactstrap-validation"
import Select from "react-select"

import { Link, useHistory, Redirect } from "react-router-dom"

import apiResponse from '../../../../../services/apiResponse'

import CreateBloc from './Blocs/CreateBloc'
import PegawaiSideBar from '../../../GlobalComponents/PegawaiSidebar'
import { accessRole } from "../../../../../helpers/access_role"
import DatePicker from '../../../../../helpers/ui/DatePicker'


var reformatOptionRegion = function(regions) {
  return regions.map(function(region) {
    var newObj = {};
    newObj["label"] = region.region_name;
    newObj["value"] = region.region_uuid;

    return newObj;
  });
};

const jobType = [
    { value: 1, label: 'PNS BKPM' },
    { value: 2, label: 'PNS Non BKPM' },
    { value: 3, label: 'Non PNS' },
    { value: 4, label: 'Tidak Bekerja'}
]


class IndexView extends Component {

    createBloc = new CreateBloc();

    // Retrieve Data Pegawai by Admin / Pegawai
    userdata = JSON.parse(localStorage.getItem('userdata'));
    employeeSeleted = JSON.parse(localStorage.getItem('employeeSelected'));
    peg_uuid = !accessRole('approve') ? (this.userdata != null ? this.userdata.employee_uuid : "") 
    : (this.employeeSeleted != null ? this.employeeSeleted.employee_uuid : "")

    constructor(props) {
        super(props)
        this.state = {
            luarNegeri:"",
            dalamNegeri:"",
            dataForm: {},
            optionGender : [
              { label: "Laki-laki", value: "L" },
              { label: "Perempuan", value: "P" }
            ],
            optionPosition: [],
            optionTempatLahir : [
                { label: "Dalam Negeri", value: "1" },
                { label: "Luar Negeri", value: "2" }
              ],
            selectedGender: "",
            selectedTempatLahir: "",
            selectedPosition: "",
            birthOptionCountry: [],
            birthSelectedCountry: "", // Indonesia
            birthOptionProvince : [],
            birthSelectedProvince: "",
            birthOptionCity : [],
            birthSelectedCity: "",
            birthOptionProvince2 : [],
            birthSelectedProvince2: "",
            birthOptionCity2 : [],
            birthSelectedCity2: ""
        }
    }

    // Select Area

    handleBirthSelectProvince = (birthSelectedProvince) => {
      this.setState({
        birthSelectedProvince: birthSelectedProvince.value
      });

      // get data city where province selected
      this.createBloc.regionCityChannel.subscribe((result) => {
          switch (result.status) {
              case apiResponse.COMPLETED:
                  if(result.data.status) {
                      let response = result.data.response
                      //console.log(response)
                      this.setState({
                          birthOptionCity: reformatOptionRegion(response.result)
                      })
                  }
                  break
              case apiResponse.ERROR:
                  
                  break
              default:
                  break
          }
      })
      this.createBloc.fetchRegionCity({
        is_local: 1,
        type : 3,
        parent_uuid : birthSelectedProvince.value
      })
    }

    handleBirthSelectProvince2 = (birthSelectedProvince) => {
        this.setState({
            birthSelectedProvince2: birthSelectedProvince.value
        });
  
        // get data city where province selected
        this.createBloc.regionCityChannel2.subscribe((result) => {
            switch (result.status) {
                case apiResponse.COMPLETED:
                    if(result.data.status) {
                        let response = result.data.response
                        //console.log(response)
                        this.setState({
                            birthOptionCity2: reformatOptionRegion(response.result)
                        })
                    }
                    break
                case apiResponse.ERROR:
                    
                    break
                default:
                    break
            }
        })
        this.createBloc.fetchRegionCity2({
          is_local: 1,
          type : 3,
          parent_uuid : birthSelectedProvince.value
        })
      }

    handleBirthSelectCity = (birthSelectedCity) => {
      this.setState({
        birthSelectedCity: birthSelectedCity.value
      });
    }

    handleBirthSelectCity2 = (birthSelectedCity) => {
        this.setState({
          birthSelectedCity2: birthSelectedCity.value
        });
      }

    handleBirthSelectCountry = (birthSelectedCountry) => {
        this.setState({
            birthSelectedCountry: birthSelectedCountry.value
        });
    }

    handleSelectGender = (selectedGender) => {
      this.setState({
        selectedGender: selectedGender.value
      });
    }

    handleSelectTempatLahir = (selectedTempatLahir) => {
        var status = parseInt(selectedTempatLahir.value)
        if(status === 1){
            // Dalam Negeri
            this.createBloc.fetchRegionCountries({
                type : 1  
            })
            this.setState({
                selectedTempatLahir: selectedTempatLahir.value,
                luarNegeri: "",
                dalamNegeri:"none",
                birthSelectedCountry: "61b47307-167d-489f-bb6c-c1c9662acab3"
            });
            
        }else{
             // Luar Negeri
            this.setState({
                selectedTempatLahir: selectedTempatLahir.value,
                luarNegeri: "none",
                dalamNegeri:"",
                birthSelectedCountry: ""
            });
            this.createBloc.fetchRegionCountries({
                is_local: 0, 
                type : 1  
            })
        }
        this.setState({
            selectedTempatLahir: selectedTempatLahir.value
        });
      }

    handleSelectPosition = (selectedPosition) => {
        this.setState({
            selectedPosition: selectedPosition.value
        });
      }

    // End Select Area

    submitData = async () => {
        if(this.state.dataForm.document.length > 0){
            let formData = generateFormData(this.state.dataForm, 'document')
            //console.log(this.state.dataForm)
            await this.createBloc.fetchCreate(formData)
        }else{
            await this.createBloc.fetchCreate(this.state.dataForm)
        }       
    }

    handlerOnSubmit = (e, values) => {
        e.preventDefault()
        this.setState({
            dataForm: {
              employee_uuid : this.peg_uuid,
              ...values
            },
            confirm: true
        })
    }

    confirmResponse = (response) => {
        let forState = {}
        switch(response) {
            case 'cancel':
                forState = {
                    confirm: false
                }
                break;
            case 'confirm':
                forState = {
                    loading: true,
                    confirm: false
                }
                this.submitData()
                break;
            case 'success':
                forState = {
                    success: false,
                    redirect: true
                }
                break;
             case 'failed':
                forState = {
                    failed: false
                }
                break;
            default:       
        }
        this.setState(forState)
    }

    componentDidMount() {
        this.createBloc.createChannel.subscribe((result) => {
            switch (result.status) {
                case apiResponse.COMPLETED:
                    this.setState({
                        loading: false,
                        success: true,
                    });
                    break
                case apiResponse.ERROR:
                    this.setState({
                        loading: false,
                        failed: true,
                    });
                    break
                default:
                    break
            }
        })

        // get data province
        this.createBloc.regionProvinceChannel.subscribe((result) => {
            switch (result.status) {
                case apiResponse.COMPLETED:
                    if(result.data.status) {
                        let response = result.data.response
                        //console.log(response)
                        this.setState({
                            birthOptionProvince: reformatOptionRegion(response.result)
                        })
                    }
                    break
                case apiResponse.ERROR:
                    
                    break
                default:
                    break
            }
        })

        this.createBloc.regionProvinceChannel2.subscribe((result) => {
            switch (result.status) {
                case apiResponse.COMPLETED:
                    if(result.data.status) {
                        let response = result.data.response
                        //console.log(response)
                        this.setState({
                            birthOptionProvince2: reformatOptionRegion(response.result)
                        })
                    }
                    break
                case apiResponse.ERROR:
                    
                    break
                default:
                    break
            }
        })

        this.createBloc.regionCountryChannel.subscribe((result) => {
            switch (result.status) {
                case apiResponse.COMPLETED:
                    if(result.data.status) {
                        let response = result.data.response
                        //console.log(response)
                        this.setState({
                            birthOptionCountry: reformatOptionRegion(response.result)
                        })
                    }
                    break
                case apiResponse.ERROR:
                    break
                default:
                    break
            }
        })

         this.createBloc.positionChannel.subscribe((result) => {
            switch (result.status) {
                case apiResponse.COMPLETED:
                    if(result.data.status) {
                        let response = result.data.response
                         this.setState({
                            optionPosition: response
                        })
                    }
                    break
                case apiResponse.ERROR:
                    
                    break
                default:
                    break
            }
         })
        
        this.createBloc.fetchPosition({
          uuid: this.peg_uuid
        })

        this.createBloc.fetchRegionProvince({
          is_local: 1,
          type : 2  
        })

        this.createBloc.fetchRegionProvince2({
            is_local: 1,
            type : 2  
          })

        this.createBloc.fetchRegionCountries({
            type : 1  
        })
        this.setState({
            selectedTempatLahir: "1",
            luarNegeri: "",
            dalamNegeri:"none",
            birthSelectedCountry: "61b47307-167d-489f-bb6c-c1c9662acab3"
        });
      
        
    }

    render() {
        return (
            <Fragment>
                <Container fluid>
                    <Row>
                        <Col className="col-12">

                            <PegawaiSideBar active="orangtua"/>

                            <Card className="pegawai-rightbar">
                                <CardBody>
                                    <CardTitle>Data Orang Tua</CardTitle>
                                    <CardSubtitle className="mb-3">
                                        Setiap isian yang bertanda (<span className="text-danger">*</span>) adalah wajib diisi.
                                    </CardSubtitle>
                                    <hr />
                                        <AvForm
                                            className="needs-validation"
                                            onValidSubmit={(e, values) => this.handlerOnSubmit(e, values)}
                                        >

                                            <Row className="mb-3">
                                                <label
                                                    htmlFor=""
                                                    className="col-md-3 col-form-label"
                                                >
                                                Nama Lengkap <span className="text-danger">*</span>
                                                </label>
                                                <Col md="5">
                                                    <AvField
                                                        name="family_name"
                                                        placeholder="Nama..."
                                                        type="text"
                                                        errorMessage="Masukkan Nama"
                                                        className="form-control"
                                                        validate={{ required: { value: true } }}
                                                        id="name"
                                                    />
                                                </Col>
                                            </Row>

                                            <Row className="mb-3">
                                                <label
                                                    htmlFor=""
                                                    className="col-md-3 col-form-label"
                                                >
                                                Posisi Dalam Keluarga <span className="text-danger">*</span>
                                                </label>
                                                <Col md="5">
                                                    <CustomSelect 
                                                        name="family_gender"
                                                        validate={{ required: { value: true } }}
                                                        options={[
                                                            { value: 'P', label: 'Ibu' },
                                                            { value: 'L', label: 'Ayah' },
                                                        ]}
                                                    />
                                                </Col>
                                            </Row>

                                            <Row className="mb-3">
                                                <label className="col-md-3 col-form-label">
                                                    Nomor Induk Kependudukan
                                                    {/* <span className="text-danger">*</span> */}
                                                </label>
                                                <Col md="5">
                                                    <AvField
                                                    name="family_identity_number"
                                                    placeholder="Nomor Induk Kependudukan..."
                                                    type="text"
                                                    errorMessage="Masukkan Nomor Induk Kependudukan"
                                                    className="form-control"
                                                    // validate={{ required: { value: true } }}
                                                    id="family_identity_number"
                                                    />
                                                </Col>
                                                </Row>

                                            <Row className="mb-3">
                                                <label className="col-md-3 col-form-label">
                                                    Nomor Kartu Keluarga 
                                                    {/* <span className="text-danger">*</span> */}
                                                </label>
                                                <Col md="4">
                                                    <AvField
                                                    name="familty_family_card_number"
                                                    placeholder="Nomor Kartu Keluarga..."
                                                    type="text"
                                                    errorMessage="Masukkan Nomor Kartu Keluarga"
                                                    className="form-control"
                                                    id="familty_family_card_number"
                                                    />
                                                </Col>
                                            </Row>

                                            
                                            
                                            <hr />
                                            <Row>
                                                <Col md="5">
                                                    <label className="fw-bold">#Tempat & Tanggal Lahir</label>
                                                </Col>
                                            </Row>

                                            <Row className="mb-3">
                                                <label
                                                    htmlFor=""
                                                    className="col-md-3 col-form-label"
                                                >
                                                Dalam / Luar Negeri <span className="text-danger">*</span>
                                                </label>
                                                <Col md="5">
                                                    <CustomSelect 
                                                        options={this.state.optionTempatLahir}
                                                        name="family_place_of_birth_national"
                                                        value={this.state.selectedTempatLahir}
                                                        onChange={opt => this.handleSelectTempatLahir(opt)}
                                                        placeholder="Pilih Dalam / Luar Negeri"
                                                    />
                                                    {/* <Select
                                                        value={this.state.optionTempatLahir.filter(option => 
                                                            option.value === this.state.selectedTempatLahir)}
                                                        onChange={
                                                            this.handleSelectTempatLahir
                                                        }
                                                        required="required"
                                                        placeholder="Pilih Dalam / Luar Negeri"
                                                        options={this.state.optionTempatLahir}
                                                        classNamePrefix="select2-tempat-lahir"
                                                        />
                                                        <AvField
                                                            name="tempat-lahir-selected"
                                                            type="hidden"
                                                            errorMessage="Pilih Dalam / Luar Negeri"
                                                            validate={{ required: { value: true } }}
                                                            id="tempat-lahir-selected"
                                                            value={this.state.selectedTempatLahir}
                                                        /> */}
                                                </Col>
                                            </Row>

                                            {
                                                !this.state.dalamNegeri &&
                                                    <Row className="mb-3">
                                                        <label
                                                            htmlFor=""
                                                            className="col-md-3 col-form-label"
                                                        >
                                                        Negara <span className="text-danger">*</span>
                                                        </label>
                                                        <Col md="5">
                                                            <CustomSelect 
                                                                name="family_place_of_birth_country_uuid"
                                                                options={this.state.birthOptionCountry}
                                                                value={this.state.birthSelectedCountry}
                                                                placeholder="Negara.."
                                                            />
                                                            {/* <Select
                                                                value={this.state.birthOptionCountry.filter(option => 
                                                                option.value === this.state.birthSelectedCountry)}
                                                                onChange={
                                                                this.handleBirthSelectCountry
                                                                }
                                                                required="required"
                                                                options={this.state.birthOptionCountry}
                                                                classNamePrefix="select2-country"
                                                            />

                                                            <AvField
                                                                name="country_uuid"
                                                                placeholder="Negara"
                                                                type="hidden"
                                                                errorMessage="Masukkan Negara"
                                                                className="form-control"
                                                                id="negara"
                                                                value={this.state.birthSelectedCountry}
                                                            /> */}
                                                        </Col>
                                                    </Row>
                                            }

                                            {
                                                this.state.dalamNegeri &&
                                                    <Row className="mb-3">
                                                        <label
                                                            htmlFor=""
                                                            className="col-md-3 col-form-label"
                                                        >
                                                        Provinsi 
                                                        </label>
                                                        <Col md="5">
                                                            <CustomSelect 
                                                                name="family_place_of_birth_province"
                                                                options={this.state.birthOptionProvince2}
                                                                placeholder="Provinsi Lahir..."
                                                                onChange={opt => this.handleBirthSelectProvince2(opt)}
                                                            />
                                                            {/* <Select
                                                                value={this.state.birthOptionProvince2.filter(option => 
                                                                option.value === this.state.birthSelectedProvince2)}
                                                                onChange={
                                                                this.handleBirthSelectProvince2
                                                                }
                                                            
                                                                options={this.state.birthOptionProvince2}
                                                                classNamePrefix="select2-gender"
                                                            />

                                                            <AvField
                                                                name="keluarga_orangtua_of_birth_province_uuid"
                                                                placeholder="Provinsi Lahir..."
                                                                type="hidden"
                                                                errorMessage="Masukkan Provinsi Lahir"
                                                                className="form-control"
                                                                id="keluarga_orangtua_of_birth_province_uuid"
                                                                value={this.state.birthSelectedProvince2}
                                                            /> */}
                                                        </Col>
                                                    </Row>
                                            }
                                            { this.state.dalamNegeri &&
                                                <Row className="mb-3">
                                                    <label
                                                        htmlFor=""
                                                        className="col-md-3 col-form-label"
                                                    >
                                                    Kabupaten / Kota 
                                                    </label>
                                                    <Col md="5">
                                                        <CustomSelect 
                                                            name="family_place_of_birth_city_uuid"
                                                            options={this.state.birthOptionCity2}
                                                            placeholder="Kota Lahir..."
                                                            onChange={opt => this.handleBirthSelectCity2(opt)}
                                                        />
                                                        {/* <Select
                                                            value={this.state.birthOptionCity2.filter(option => 
                                                            option.value === this.state.birthSelectedCity2)}
                                                            onChange={
                                                            this.handleBirthSelectCity2
                                                            }
                                                            
                                                            options={this.state.birthOptionCity2}
                                                            classNamePrefix="select2-gender"
                                                        />
                                                        
                                                        <AvField
                                                            name="keluarga_orangtua_of_birth_regency_uuid"
                                                            placeholder="Kota Lahir..."
                                                            type="hidden"
                                                            errorMessage="Masukkan Kota Lahir"
                                                            className="form-control"
                                                            id="keluarga_orangtua_of_birth_regency_uuid"
                                                            value={this.state.birthSelectedCity2}
                                                        /> */}
                                                    </Col>
                                                </Row>
                                            }

                                            { !this.state.dalamNegeri && 
                                                <Row className="mb-3">
                                                    <label
                                                        htmlFor=""
                                                        className="col-md-3 col-form-label"
                                                    >
                                                    Kota 
                                                    </label>
                                                    <Col md="5">
                                                        <AvField
                                                            name="family_place_of_birth_city_text"
                                                            placeholder="Kota..."
                                                            type="text"
                                                            errorMessage="Kota"
                                                            className="form-control"
                                                            id="keluarga_orangtua_of_birth_regency_name"
                                                        />
                                                    </Col>
                                                </Row>
                                            }

                                            <Row className="mb-3">
                                                <label
                                                    htmlFor=""
                                                    className="col-md-3 col-form-label"
                                                >
                                                Tanggal Lahir <span className="text-danger">*</span>
                                                </label>
                                                <Col md="5">
                                                    {/* <AvField
                                                        name="family_date_of_birth"
                                                        placeholder="Tanggal Lahir..."
                                                        type="date"
                                                        errorMessage="Masukkan Tanggal Lahir"
                                                        className="form-control"
                                                        validate={{ required: { value: true } }}
                                                        id="date_of_birth"
                                                    /> */}
                                                    <DatePicker 
                                                        name={`family_date_of_birth`}
                                                        isWeekday={false}
                                                        dateFormat="dd/MM/yyyy"
                                                        errorMessage="Masukan Tanggal Lahir"
                                                        validate={{ required: { value: true } }}
                                                    />
                                                </Col>
                                            </Row>

                                            <Row className="mb-3">
                                                <label
                                                    htmlFor=""
                                                    className="col-md-3 col-form-label"
                                                >
                                                Status <span className="text-danger">*</span>
                                                </label>
                                                <Col md="5">
                                                    <CustomSelect
                                                        name="family_is_alive"
                                                        placeholder="Status..."
                                                        errorMessage="Masukkan Status"
                                                        validate={{ required: { value: true } }}
                                                        options={[
                                                            { value: 1, label: 'Hidup' },
                                                            { value: 0, label: 'Meninggal' },
                                                        ]}
                                                    />
                                                </Col>
                                            </Row>

                                            <hr />
                                            <Row>
                                                <Col md="5">
                                                    <label className="fw-bold">#Informasi Lainnya</label>
                                                </Col>
                                            </Row> 

                                            <Row className="mb-3">
                                                <label
                                                    htmlFor=""
                                                    className="col-md-3 col-form-label"
                                                >
                                                Pekerjaan <span className="text-danger">*</span>
                                                </label>
                                                <Col md="5">
                                                    <CustomSelect
                                                        name="family_spouse_job_type"
                                                        placeholder="Pekerjaan..."
                                                        errorMessage="Masukkan Pekerjaan"
                                                        validate={{ required: { value: true } }}
                                                        options={jobType}
                                                    />
                                                </Col>
                                            </Row>

                                            <Row className="mb-3">
                                                <label
                                                    htmlFor=""
                                                    className="col-md-3 col-form-label"
                                                >
                                                Provinsi <span className="text-danger">*</span>
                                                </label>
                                                <Col md="5">
                                                    <CustomSelect 
                                                        name="family_identity_province_uuid"
                                                        options={this.state.birthOptionProvince}
                                                        onChange={opt => this.handleBirthSelectProvince(opt)}
                                                        placeholder="Provinsi Tinggal ..."
                                                        errorMessage="Masukkan Provinsi Tinggal"
                                                        validate={{ required: { value: true } }}
                                                    />
                                                </Col>
                                            </Row>

                                            <Row className="mb-3">
                                                <label
                                                    htmlFor=""
                                                    className="col-md-3 col-form-label"
                                                >
                                                Kabupaten / Kota <span className="text-danger">*</span>
                                                </label>
                                                <Col md="5">
                                                    <CustomSelect 
                                                        name="family_identity_city_uuid"
                                                        options={this.state.birthOptionCity}
                                                        onChange={opt => this.handleBirthSelectCity(opt)}
                                                        placeholder="Kota Tinggal ..."
                                                        errorMessage="Masukkan Kota Tinggal"
                                                        validate={{ required: { value: true } }}
                                                    />
                                                </Col>
                                            </Row>

                                            <Row className="mb-3">
                                                <label
                                                    htmlFor=""
                                                    className="col-md-3 col-form-label"
                                                >
                                                Kode Pos <span className="text-danger">*</span>
                                                </label>
                                                <Col md="5">
                                                    <AvField
                                                        name="family_identity_postal_code"
                                                        placeholder="Kode Pos..."
                                                        type="text"
                                                        errorMessage="Masukkan Kode Pos"
                                                        className="form-control"
                                                        validate={{ required: { value: true } }}
                                                        id="postal_code"
                                                    />
                                                </Col>
                                            </Row>

                                            <Row className="mb-3">
                                                <label
                                                    htmlFor=""
                                                    className="col-md-3 col-form-label"
                                                >
                                                Telepon <span className="text-danger">*</span>
                                                </label>
                                                <Col md="5">
                                                    <AvField
                                                        name="family_phone_number"
                                                        placeholder="Nomor Telepon..."
                                                        type="text"
                                                        errorMessage="Masukkan Nomor Telepon"
                                                        className="form-control"
                                                        validate={{ required: { value: true } }}
                                                        id="phone"
                                                    />
                                                </Col>
                                            </Row>

                                            <Row className="mb-3">
                                                <label
                                                    htmlFor=""
                                                    className="col-md-3 col-form-label"
                                                >
                                                Alamat Lengkap <span className="text-danger">*</span>
                                                </label>
                                                <Col md="5">
                                                    <AvField
                                                        name="family_identity_address"
                                                        placeholder="Alamat..."
                                                        type="textarea"
                                                        errorMessage="Masukkan Alamat"
                                                        className="form-control"
                                                        rows="8"
                                                        validate={{ required: { value: true } }}
                                                        id="address"
                                                    />
                                                </Col>
                                            </Row>

                                            <Row className="mb-3">
                                            <label
                                                htmlFor="no_sk"
                                                className="col-md-3 col-form-label"
                                            >
                                            Lampiran
                                            </label>
                                            <Col md="5">
                                                <FileInput 
                                                    name="document"
                                                />
                                            </Col>
                                        </Row>

                                      
                                        <Row className="mb-3">
                                            <Col md="3"></Col>
                                            <Col md="9">
                                                <div className="form-check form-switch mb-3">
                                                <AvCheckboxGroup name="checkboxExample" required errorMessage="Agreement harus di centang">
                                                    <AvCheckbox label="Saya yakin dan bertanggung jawab atas data ini" value="1" />
                                                </AvCheckboxGroup>
                                                
                                                </div>
                                            </Col>
                                        </Row>
                                        <Row className="mb-3">
                                            <Col md="3"></Col>
                                            <Col md="9">
                                                <Link to="/kepegawaian/home.html?orangtua">
                                                    <Button color="danger"><i className="uil-arrow-left"></i> Kembali</Button>
                                                </Link>
                                                {' '}
                                                <Button color="success" type="submit">
                                                    <i className="uil-arrow-up-right"></i> Simpan Data
                                                </Button>
                                            </Col>
                                        </Row>
                                    </AvForm>
                                </CardBody>
                            </Card>
                        </Col>
                    </Row>
                </Container>
                <ConfirmAlert
                    confirmTitle="Konfirmasi!"
                    confirmInfo="Apakah anda yakin akan menyimpan data ini?"

                    loadingTitle="Mengirim data..."
                    loadingInfo="Tunggu beberapa saat"

                    successTitle="Berhasil!"
                    successInfo="Data berhasil disimpan"

                    failedTitle="Gagal!"
                    failedInfo="Data gagal disimpan"

                    showConfirm={this.state.confirm}
                    showLoading={this.state.loading}
                    showSuccess={this.state.success}
                    showFailed={this.state.failed}

                    response={this.confirmResponse}
                />
                { this.state.redirect ?
                    <Redirect to='/kepegawaian/home.html?orangtua'/>
                : null }
            </Fragment>
        )
    }

}

export default IndexView